import { getRelativeDate } from '../utils/dateHelpers';

export const events = [
  {
    id: 1,
    title: "Roseville Winter Farmers Market",
    date: getRelativeDate(2),
    time: "8:00 AM - 1:00 PM",
    location: "Downtown Roseville Plaza",
    category: "Community",
    image: "https://public.readdy.ai/ai/img_res/0d1f29efbe2d67af9cc851adbb5d44c8.jpg",
    description: "Shop fresh, locally-grown produce and artisan goods from regional farmers and craftspeople.",
    featured: true,
    price: "Free"
  },
  {
    id: 2,
    title: "Live Music at The Monk's Cellar",
    date: getRelativeDate(3),
    time: "7:00 PM - 10:00 PM",
    location: "The Monk's Cellar",
    category: "Music",
    image: "https://readdy.ai/api/search-image?query=intimate%20live%20music%20performance%20in%20cozy%20pub%20setting%2C%20acoustic%20band%20on%20stage%2C%20audience%20enjoying%20drinks%2C%20warm%20atmospheric%20lighting%2C%20local%20music%20venue&width=800&height=500&seq=event2&orientation=landscape",
    description: "Enjoy an evening of acoustic performances by local artists in an intimate setting.",
    featured: true,
    price: "$10"
  },
  {
    id: 3,
    title: "Family Movie Night at Mahany Park",
    date: getRelativeDate(7),
    time: "6:30 PM",
    location: "Mahany Park",
    category: "Family",
    image: "https://readdy.ai/api/search-image?query=outdoor%20movie%20screening%20in%20park%20at%20dusk%2C%20large%20screen%2C%20families%20on%20blankets%2C%20community%20movie%20night%2C%20string%20lights%2C%20relaxed%20evening%20atmosphere&width=800&height=500&seq=event3&orientation=landscape",
    description: "Bring your blankets and enjoy a family-friendly movie under the stars.",
    featured: false,
    price: "Free"
  },
  {
    id: 4,
    title: "Roseville Art Walk",
    date: getRelativeDate(8),
    time: "5:00 PM - 9:00 PM",
    location: "Historic Downtown",
    category: "Arts",
    image: "https://readdy.ai/api/search-image?query=evening%20art%20walk%20in%20downtown%20district%2C%20galleries%20with%20artwork%20displays%2C%20people%20viewing%20art%2C%20street%20performers%2C%20cultural%20event%20atmosphere%2C%20warm%20evening%20lighting&width=800&height=500&seq=event4&orientation=landscape",
    description: "Explore local galleries, meet artists, and enjoy live demonstrations throughout downtown.",
    featured: true,
    price: "Free"
  },
  {
    id: 5,
    title: "Youth Basketball Tournament",
    date: getRelativeDate(15),
    time: "9:00 AM - 5:00 PM",
    location: "Roseville Sports Center",
    category: "Sports",
    image: "https://readdy.ai/api/search-image?query=youth%20basketball%20game%20in%20modern%20indoor%20sports%20facility%2C%20young%20players%20competing%2C%20parents%20cheering%2C%20energetic%20sports%20tournament%20atmosphere%2C%20bright%20gymnasium&width=800&height=500&seq=event5&orientation=landscape",
    description: "Annual youth basketball championship featuring teams from across Placer County.",
    featured: false,
    price: "$5"
  },
  {
    id: 6,
    title: "Cooking Class: Italian Cuisine",
    date: getRelativeDate(19),
    time: "6:00 PM - 9:00 PM",
    location: "Culinary Arts Studio",
    category: "Food",
    image: "https://readdy.ai/api/search-image?query=hands-on%20cooking%20class%20with%20chef%20instructor%2C%20students%20preparing%20Italian%20dishes%2C%20professional%20kitchen%20setting%2C%20fresh%20ingredients%2C%20culinary%20education%20atmosphere&width=800&height=500&seq=event6&orientation=landscape",
    description: "Learn to prepare authentic Italian dishes with Chef Marco Rossi.",
    featured: false,
    price: "$75"
  },
  {
    id: 7,
    title: "Roseville Spring Festival",
    date: getRelativeDate(22),
    time: "10:00 AM - 6:00 PM",
    location: "Mahany Park",
    category: "Festival",
    image: "https://readdy.ai/api/search-image?query=large%20outdoor%20spring%20festival%20with%20colorful%20tents%2C%20carnival%20rides%2C%20food%20vendors%2C%20live%20entertainment%20stage%2C%20families%20enjoying%20activities%2C%20festive%20celebration%20atmosphere&width=800&height=500&seq=event7&orientation=landscape",
    description: "Three-day celebration featuring live music, food vendors, carnival rides, and family activities.",
    featured: true,
    price: "$15"
  },
  {
    id: 8,
    title: "Business Networking Breakfast",
    date: getRelativeDate(5),
    time: "7:30 AM - 9:00 AM",
    location: "Roseville Chamber of Commerce",
    category: "Business",
    image: "https://readdy.ai/api/search-image?query=professional%20business%20networking%20event%2C%20diverse%20professionals%20mingling%20with%20coffee%2C%20modern%20conference%20setting%2C%20business%20casual%20attire%2C%20morning%20networking%20atmosphere&width=800&height=500&seq=event8&orientation=landscape",
    description: "Connect with local business leaders and entrepreneurs over breakfast.",
    featured: false,
    price: "$25"
  }
];